/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorpanel_Troubleshoot_Step2description2Inputs */

const en_errorpanel_troubleshoot_step2description2 = /** @type {(inputs: Errorpanel_Troubleshoot_Step2description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensure you have stable internet access`)
};

/**
* | output |
* | --- |
* | "Ensure you have stable internet access" |
*
* @param {Errorpanel_Troubleshoot_Step2description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errorpanel_troubleshoot_step2description2 = /** @type {((inputs?: Errorpanel_Troubleshoot_Step2description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorpanel_Troubleshoot_Step2description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errorpanel_troubleshoot_step2description2(inputs)
});
export { errorpanel_troubleshoot_step2description2 as "errorPanel_troubleshoot_step2Description" }